module.exports = __webpack_public_path__ + "img/icon-16-back.fa87958f.svg";